export function LocalImageLoader({ src, width, quality }) {
  var fileName = src.split("/").pop();
  return `/_next/static/media/${fileName}`;
}

export function ExternalImageLoader({ src, width, quality }) {
  return src;
}
